import type { ReactNode } from "react";
import { faviconUrl } from "../../assets";

export function BrandMark({
  className = "size-9",
}: {
  className?: string;
}): ReactNode {
  return (
    <img src={faviconUrl} alt="" aria-hidden="true" className={className} />
  );
}
